"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsApplicableForGroupOnboarding = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.IsApplicableForGroupOnboarding = {
    priority: 2,
    label: 'fields.payload.mor_group_answers.is_applicable_for_group_onboarding.label',
    fallbackLabel: 'Do you confirm that the above statement is true?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Boolean,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
